module.exports = __webpack_public_path__ + "static/img/22153C_8_C_20230601_LC.8f5d802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/22153C_8_C_20230601_LC.png
// module id = zx2o
// module chunks = 0